module.exports = __webpack_public_path__ + "img/TKM.ee1d47cd.gif";